import axios from 'axios';
import { isPaymentRequiredError, redirectToPaidSignup, shouldLogoutOnAuthError } from './authErrors';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const API = `${BACKEND_URL}/api`;

// Create axios instance with base configuration
const axiosInstance = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Request interceptor to add auth token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (shouldLogoutOnAuthError(error)) {
      localStorage.removeItem('auth_token');
      window.location.href = '/login';
    } else if (isPaymentRequiredError(error)) {
      redirectToPaidSignup();
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
